import React from 'react'
import { createRoot } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'

module.exports = function (AdminLogin) {
  const container = document.getElementById('main')
  const root = createRoot(container)

  function LoginApp () {
    return (
      <BrowserRouter>
        <AdminLogin />
      </BrowserRouter>
    )
  }

  root.render(<LoginApp />)
}
